import { selectProcedureStepById } from "@overmap-ai/core"
import { createFileRoute, notFound, Outlet } from "@tanstack/react-router"
import { appStore } from "src/store"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId",
)({
	component: Outlet,
	loader: ({ params }) => {
		const procedureStep = selectProcedureStepById(params.procedureStepId)(appStore.getState())
		if (!procedureStep || procedureStep.procedure_type !== params.procedureTypeId) throw notFound()
		return procedureStep
	},
})
